import { getMenus } from 'apps/menu/selectors/menuListSelectors'
import { ActionTypes } from 'common/actions'
import { Action } from 'common/actions/models/Action/action'
import { formatActionValue } from 'common/actions/models/Action/actionValue'
import { getActionName as getActionNameFormatted } from 'common/actions/models/Action/formatters'
import { VIRTUAL_FLOW_ID } from 'common/builder/components/aiAssistantFlowViewer/hooks/useVirtualBuilder'
import { getById } from 'common/builder/selectors/builder/builderStateSelectors'
import { getFlowPersonalizationFields } from 'common/builder/selectors/builder/fieldsSelectors'
import {
  getBotTimezone,
  getInstalledApplications,
  getApplicationById,
  getCurrentAccount,
} from 'common/core/selectors/appSelectors'
import { getCustomEventsItems } from 'common/events/selectors/eventSelectors'
import { getAutoAssignGroups } from 'common/groups/selectors/groupsSelectors'
import * as sequenceSelectors from 'common/sequences/selectors/sequenceSelectors'
import { getBotAgents } from 'common/settings/selectors/botSettingsSelectors'

export const getActionName = (state: RootState, action: Action) => {
  const installedApplications = getInstalledApplications(state)
  return getActionNameFormatted(action, { installedApplications })
}

export const getActionValue = (state: RootState, action: Action, builderId: string) => {
  const flows = state.flow.byId
  const admins = getBotAgents(state)
  const builderState = getById(state, builderId)
  const tags =
    builderState?.flow === VIRTUAL_FLOW_ID
      ? getById(state, builderId).draftDependencies.tags
      : state.tags.items || []
  const sequences = sequenceSelectors.getList(state)
  const zaps = state.zaps?.items || []
  const botTimezone = getBotTimezone(state)
  const events = getCustomEventsItems(state)
  const menus = getMenus(state)
  const application =
    action.type === ActionTypes.APPS_REQUEST && action.app_id
      ? getApplicationById(action.app_id)(state)
      : null
  const currentAccount = getCurrentAccount(state)
  const emailInsteadOfMessengerEnabled = currentAccount.suspend_notify_admin_by_messenger
  const fields = getFlowPersonalizationFields(state, builderId)
  const autoAssignGroups = getAutoAssignGroups(state)

  return formatActionValue(
    action,
    {
      tags,
      sequences,
      fields,
      flows,
      admins,
      zaps,
      events,
      application,
      menus,
      autoAssignGroups,
      withGroups: Boolean(autoAssignGroups?.length),
    },
    {
      botTimezone,
      emailInsteadOfMessengerEnabled,
    },
  )
}
